function runCountdowns() {

  // Page produit (id unique)
  const timerEl = document.getElementById('product-countdown');
  if (timerEl) {
    const releaseDate = new Date(timerEl.dataset.releaseDate);
    const buyBtn = document.querySelector('#product-add-to-cart');
    initSingleCountdown(timerEl, releaseDate, buyBtn);
  }

  // Cards produit (multiples)
  document.querySelectorAll('.product-countdown-card').forEach(function(cardTimer) {
    if (cardTimer.dataset.initialized) return;
    cardTimer.dataset.initialized = 'true';
    const releaseDate = new Date(cardTimer.dataset.releaseDate);
    const buyBtn = cardTimer.parentElement.querySelector('[data-btn-addToCart]');
    initSingleCountdown(cardTimer, releaseDate, buyBtn);
  });

  function initSingleCountdown(el, releaseDate, buyBtn) {
    function updateTimer() {
      const now = new Date();
      const diff = releaseDate - now;

      if (diff <= 0) {
        el.style.display = 'none';
        if (buyBtn) buyBtn.style.display = '';
        return;
      }

      if (buyBtn) buyBtn.style.display = 'none';

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      el.innerHTML = `
        <div class="countdown-wrap">
          <p class="countdown-label">Disponible dans</p>
          <div class="countdown-blocks">
            <div class="countdown-block"><span>${days}</span><small>Jours</small></div>
            <div class="countdown-block"><span>${hours}</span><small>Heures</small></div>
            <div class="countdown-block"><span>${mins}</span><small>Min</small></div>
            <div class="countdown-block"><span>${secs}</span><small>Sec</small></div>
          </div>
        </div>`;

      setTimeout(updateTimer, 1000);
    }
    updateTimer();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runCountdowns);
} else {
  runCountdowns();
}
